import { ButtonBuy_Container, ButtonBuy_Content, ButtonBuy_Loader } from "./ButtonBuy.styled";
import { useTranslation } from "react-i18next";
import { AnimatePresence } from "framer-motion";
import { ReactNode, useState } from "react";

interface ButtonBuyProps {
	children?: ReactNode;
	onClick?: () => void | Promise<void>;
}

export const ButtonBuy = ({ children, onClick }: ButtonBuyProps) => {
	const { t } = useTranslation();

	const [isLoading, setIsLoading] = useState(false);
	const handleClick = async () => {
		if (isLoading) {
			return;
		}
		try {
			setIsLoading(true);
			await onClick?.();
		} finally {
			setIsLoading(false);
		}
	};
	return (
		<ButtonBuy_Container
			type="button"
			onClick={handleClick}
			disabled={isLoading}
			whileTap={isLoading ? undefined : { scale: 0.96 }}
			whileHover={isLoading ? undefined : { scale: 1.03 }}
			transition={{ type: "spring", stiffness: 420, damping: 24 }}
		>
			<AnimatePresence mode="wait" initial={false}>
				{isLoading ? (
					<ButtonBuy_Content
						key="loader"
						initial={{ opacity: 0, y: 6, scale: 0.9 }}
						animate={{ opacity: 1, y: 0, scale: 1 }}
						exit={{ opacity: 0, y: -6, scale: 0.9 }}
						transition={{ duration: 0.16 }}
					>
						<ButtonBuy_Loader />
					</ButtonBuy_Content>
				) : (
					<ButtonBuy_Content
						key="text"
						initial={{ opacity: 0, y: 6 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: -6 }}
						transition={{ duration: 0.16 }}
					>
						{children || t("buttons.select_plan")}
					</ButtonBuy_Content>
				)}
			</AnimatePresence>
		</ButtonBuy_Container>
	);
};
